import { isError } from 'lodash-es'

export class NoPermissionError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "NoPermissionError"
  }
}

export const isNoPermissionError = (error: unknown): error is NoPermissionError => {
  return isError(error) && error.name === "NoPermissionError"
}